import {ScrollArea as MantineScrollArea} from '@mantine/core';

/**
 * Custom-scrollbar scroll container — design-layer pass-through over Mantine `ScrollArea`.
 * @registry Pass-through Mantine ScrollArea; import this instead of @mantine/core outside src/design.
 */
export const ScrollArea = MantineScrollArea;
